  <div class="td-wb-table-card__content">
    <ng-container *ngTemplateOutlet="isExpandable() ? clickableTemplate : regularTemplate" />
    <ng-content select="td-wb-table-card-action" />
  </div>
  <ng-content select="td-wb-table-card-footer"/>
  @if (isExpanded()) {
    <div class="td-wb-table-card__detail"
         [@slideInOutAnimation]>
      @if (noOfSummaryColumns() !== undefined && columnTemplates().length > 0) {
        <div role="table"
             [attr.aria-labelledby]="getLabelledBy()">
          @for (column of columnTemplates() | slice : noOfSummaryColumns(); track column) {
            <div class="td-wb-table-card__detail-row">
              <ng-container [ngTemplateOutlet]="column.templateRef" />
            </div>
          }
        </div>
      }
      <div class="td-wb-table-card__detail-content">
        <ng-content />
      </div>
    </div>
  }

<ng-template #clickableTemplate>
  @if (isExpandable()) {
    <div (click)="toggleExpanded($event)"
         tabindex="0"
         (keydown.enter)="toggleExpanded($event)"
         class="td-wb-table-card__content-inner td-wb-table-card__content-inner--clickable">
      <ng-container *ngTemplateOutlet="expandableContentTemplate" />
    </div>
  }
</ng-template>

<ng-template #regularTemplate>
  @if (!isExpandable()) {
    <div class="td-wb-table-card__content-inner">
      <ng-container *ngTemplateOutlet="contentTemplate" />
    </div>
  }
</ng-template>

<ng-template #expandableContentTemplate>
  <h2 class="td-wb-table-card__header"
      [class.td-wb-table-card__header--expanded]="isExpanded() || !isExpandable()">
    <div class="td-wb-table-card__header-container"
         tabindex="0"
         role="button"
         [attr.aria-describedby]="headerId() + '-summary'"
         [attr.aria-expanded]="isExpanded()">
      <ng-container *ngTemplateOutlet="headerTemplate" />
      <ng-container *ngTemplateOutlet="subHeaderTemplate" />
      @if (columnTemplates().length > 0){
      <div role="table"
           [attr.id]="headerId() + '-summary'">
        @for (row of summaryRows(); track rowIndex; let rowIndex = $index) {
          <div class="td-wb-table-card__summary">
            @for (column of row; track columnIndex; let columnIndex = $index) {
              <div class="td-wb-table-card__summary-column">
                @if (column !== undefined) {
                  <ng-container [ngTemplateOutlet]="column.templateRef" />
                }
              </div>
            }
          </div>
        }
      </div>
}</div>
    <button tdWbIconButton
            [attr.id]="headerId() + '-details'"
            [attr.aria-label]="'tdWb.card.DETAILS' | tdWbTranslate"
            [attr.aria-expanded]="isExpanded()"
            [attr.aria-labelledby]="getLabelledBy()"
            class="td-wb-table-card__header-expand-button"
            (click)="toggleExpanded($event)">
      <td-wb-expand-icon class="td-wb-table-card__header-icon"
                         [expanded]="isExpanded()" />
    </button>
  </h2>
</ng-template>

<ng-template #contentTemplate>
  <h2 class="td-wb-table-card__header">
    <ng-container *ngTemplateOutlet="headerTemplate" />
  </h2>
  <ng-container *ngTemplateOutlet="subHeaderTemplate" />
  <div role="table"
       [attr.aria-labelledby]="headerId()">
    @for (row of summaryRows(); track rowIndex; let rowIndex = $index) {
      <div class="td-wb-table-card__summary">
        @for (column of row; track columnIndex; let columnIndex = $index) {
          <div class="td-wb-table-card__summary-column">
            @if (column !== undefined) {
              <ng-container [ngTemplateOutlet]="column.templateRef" />
            }
          </div>
        }
      </div>
    }
  </div>
</ng-template>

<ng-template #headerTemplate>
  <ng-content select="td-wb-table-card-header" />
</ng-template>

<ng-template #subHeaderTemplate>
  <ng-content select="td-wb-table-card-sub-header" />
</ng-template>
